<section class="ai-insights-section">
  <div class="section-header">
    <div class="header-left">
      <span class="sparkle-icon-wrap">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
          <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"/>
        </svg>
      </span>
      <div>
        <h2 class="title">AI Student Intelligence</h2>
        <p class="subtitle">AI-detected patterns across the assessed student cohort.</p>
      </div>
    </div>

    <div class="header-right">
      <span class="flow-steps">
        Detection 
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        Insight 
        <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        Action
      </span>
      <span class="active-badge">{{ totalInsights }} Active Insights</span>
    </div>
  </div>

  <div class="insights-grid">
    <div 
      *ngFor="let g of insightGroups; let i = index" 
      class="insight-card" 
      [class.card-alt]="i % 2 !== 0">
      
      <!-- Top Priority Indicator Bar -->
      <span class="priority-bar" [ngClass]="getPriorityClass(g.priority)"></span>

      <div class="card-top">
        <span class="icon-box">
          <svg *ngIf="g.id.includes('assessment')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
            <path d="m9 14 2 2 4-4"/>
          </svg>

          <svg *ngIf="g.id.includes('interview')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14 9a2 2 0 0 1-2 2H6l-4 4V4c0-1.1.9-2 2-2h8a2 2 0 0 1 2 2z"/>
          </svg>

          <svg *ngIf="g.id.includes('application')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m22 2-7 20-4-9-9-4Z"/>
          </svg>

          <svg *ngIf="g.id.includes('profile') || g.id.includes('resume')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M14.5 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7.5L14.5 2z"/>
            <circle cx="10" cy="13" r="2"/>
          </svg>

          <svg *ngIf="g.id.includes('skill')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <circle cx="12" cy="12" r="2"/>
          </svg>

          <svg *ngIf="g.id.includes('risk')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
          </svg>

          <svg *ngIf="g.id.includes('ready')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"/>
            <path d="m9 12 2 2 4-4"/>
          </svg>

          <svg *ngIf="g.id.includes('potential')" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
        </span>

        <span class="status-dot" [ngClass]="getPriorityClass(g.priority)"></span>
      </div>

      <h3 class="group-name">{{ g.name }}</h3>
      <p class="affected-count">
        <strong>{{ g.students }}</strong> {{ g.students === 1 ? 'student affected' : 'students affected' }}
      </p>

      <span class="priority-tag" [ngClass]="getPriorityClass(g.priority)">{{ g.priority }}</span>

      <p class="explanation-text">{{ g.explanation }}</p>
    </div>
  </div>
</section>
